import React, { useState, useEffect } from 'react';
import { Button, Menu, message } from "antd";
import MasterLayout from '../MasterLayout';
import BarcodePDFGenerator from "./entry/BarcodePDFGenerator";
import BarcodeScannerModal from "../BarcodeScannerModal";
import EntryDrawer from "./entry/EntryDrawer";
import EntriesTable from "./entry/EntriesTable";
import useGraphqlService from "../../util/useGraphqlService";
import { GET_ENTRIES_BY_EPISODE_QUERY, GET_ENTRY_QUERY } from "../../constants/graphql/entryQueries";
import EpisodeManager from "../EpisodeManager";
import { useEpisode } from "../../contexts/EpisodeContext";
import { GET_EPISODE_QUERY } from "../../constants/graphql/episodeQueries";

const Entry = () => {
    const [isVisible, setVisible] = useState(false);
    const [drawerVisible, setDrawerVisible] = useState(false);
    const [entryUUID, setEntryUUID] = useState('');
    const [entries, setEntries] = useState([]);
    const { sendGraphqlRequest } = useGraphqlService();
    const { episode, updateEpisode } = useEpisode();

    useEffect(() => {
        episode?.id && fetchEntries();
    }, [episode]);

    const fetchEntries = async () => {
        try {
            const data = await sendGraphqlRequest(GET_ENTRIES_BY_EPISODE_QUERY, { episodeId: episode?.id });
            console.log('Fetched entries:', data.entriesByEpisode);
            setEntries(data.entriesByEpisode);
        } catch (error) {
            console.error('Error fetching entries:', error);
            message.error('Failed to fetch entries: ' + error.message);
        }
    };

    const fetchEpisodeDetails = async () => {
        try {
            const data = await sendGraphqlRequest(GET_EPISODE_QUERY, { id: episode?.id });
            console.log('Fetched episode details:', data.episode);
            updateEpisode(data.episode);
        } catch (error) {
            console.error('Error fetching episode details:', error);
            message.error('Failed to fetch episode details: ' + error.message);
        }
    };

    const handleBarcodeScanned = async (uuid) => {
        setVisible(false);
        try {
            if (!uuid) {
                return;
            }
            console.log('Scanned UUID:', uuid);
            const data = await sendGraphqlRequest(GET_ENTRY_QUERY, { paperUuid: uuid });
            console.log('GraphQL response for entry query:', data);
            if (!data?.entry?.id) {
                setEntryUUID(uuid);
                setDrawerVisible(true);
            } else {
                message.error('UUID is not unique, please discard entry paper and scan another.');
            }
        } catch (error) {
            console.error('Error in handleBarcodeScanned:', error);
            message.error('An error occurred while processing the barcode: ' + error.message);
        }
    };

    const handleEntryCreated = (newEntry) => {
        console.log('New entry created:', newEntry);
        setDrawerVisible(false);
        setEntryUUID('');
        fetchEpisodeDetails();
        fetchEntries();
    };

    const topNavLeftContent = (
        <BarcodePDFGenerator />
    );

    return (
        <MasterLayout topNavLeftContent={topNavLeftContent}>
            <EpisodeManager />
            <Button type="primary" onClick={() => setVisible(true)}>Capture Entry</Button>
            <BarcodeScannerModal
                isVisible={isVisible}
                onClose={(scannedResult) => handleBarcodeScanned(scannedResult)}
            />
            <EntryDrawer
                visible={drawerVisible}
                onClose={() => setDrawerVisible(false)}
                initialUUID={entryUUID}
                onEntryCreated={handleEntryCreated}
            />
            <EntriesTable entries={entries} />
        </MasterLayout>
    );
};

export default Entry;